<template>
  <v-container fluid>
    <v-card outlined>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <v-form @submit.prevent="handleSubmit(onSubmit)">
          <v-card-title class="justify-center card-title">{{
            id ? $t("appointment.updateService") : $t("appointment.addNewService")
          }}</v-card-title>
          <v-card outlined class="mx-auto my-8 pa-1" max-width="425">
            <v-container>
              <language-select
                  :key="key"
                  v-model="serviceNameLang"
                  allow-add-language
                  @deleteLanguage="deleteServiceLang"
              />
              <ValidationProvider name="serviceName" rules="required" v-slot="{ errors }">
                <v-text-field
                  v-model="serviceName[serviceNameLang]"
                  :label="$t('appointment.serviceName')"
                  required
                  :disabled="!serviceNameLang"
                  :error-messages="errors"
                >
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider
                rules="required|min_value:1|max_value:240"
                name="duration"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="duration"
                  type="number"
                  :suffix="$t('appointment.min')"
                  :label="$t('appointment.appointmentDuration')"
                  :error-messages="errors"
                >
                </v-text-field>
              </ValidationProvider>
              <v-row
                class="row-appointment-default mt-6 mb-0"
                no-gutters
              >
                <v-col cols="10">
                  {{ $t("appointment.activeDefault") }}
                </v-col>
                <v-col cols="2">
                  <v-switch v-model="enabled">
                  </v-switch>
                </v-col>
              </v-row>
              <v-row
                class="row-appointment-default my-0"
                no-gutters
              >
                <v-col cols="10">
                  {{ $t("appointment.videoConference") }}
                </v-col>
                <v-col cols="2">
                  <v-switch v-model="videoConference">
                  </v-switch>
                </v-col>
              </v-row>
              <v-row
                class="row-appointment-default my-0"
                no-gutters
              >
                <v-col cols="10">
                  {{ $t("appointment.sellerService") }}
                </v-col>
                <v-col cols="2">
                  <v-switch v-model="sellerService">
                  </v-switch>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
            <v-row class="justify-center">
              <v-btn
                class="ma-2"
                color="primary"
                outlined
                type="submit"
                >{{ id ? $t("appointment.update") : $t("appointment.create") }}</v-btn
              >
            </v-row>
            <v-row v-if="id" class="justify-center">
              <v-btn
                class="ma-2"
                color="primary"
                outlined
                @click="deleteService()"
                >{{ $t("appointment.delete") }}</v-btn
              >
            </v-row>
            <v-row class="justify-center mb-5">
              <div @click="goToServicesList" id="cancel-service">
                  {{ $t("appointment.cancel") }}
              </div>
            </v-row>
        </v-form>
      </ValidationObserver>
    </v-card>
  </v-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { EventBus } from "../../event-bus";
import LanguageSelect from '@/components/LanguageSelect'

export default {
  name: "InStoreAppointmentServiceDetails",
  components: {
    ValidationProvider,
    ValidationObserver,
    LanguageSelect
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    duration_props: {
      type: Number,
      default: null,
    },
    enabled_props: {
      type: Boolean,
      default: () => false,
    },
    service_name_props: {
      type: [String, Object],
      default: null,
    },
    videoconference_props: {
      type: Boolean,
      default: () => false
    },
    seller_service_props: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      serviceName: {},
      serviceNameLang: '',
      duration: 5,
      enabled: true,
      videoConference: false,
      sellerService: false,
      key: Date.now()
    };
  },
  watch: {
    id() {
      if(this.id) {
        this.setUpdate();
      }
    }
  },
  mounted() {
    if(this.id) {
      this.setUpdate();
    }
  },
  methods: {
    onSubmit() {
      let myInit = {
        body: {
          service_name: this.serviceName,
          duration: this.duration * 60,
          enabled: this.enabled,
          videoconference: this.videoConference,
          seller_service: this.sellerService
        },
        headers: {
          Authorization: "Bearer " + this.$auth.accessToken,
        },
      };
      if(this.id) {
        this.actionService(1, myInit);
      } else {
        this.actionService(2, myInit);
      }
    },
    async actionService(type, myInit) {
      if(type === 1) {
        try {
          await this.$Amplify.API.put(
            "appointments",
            `/appointments/services/${this.id}`,
            myInit
          );
        } catch (err) {
          EventBus.$emit("displaySnackbar", {
            display: true,
            text: err.message,
            color: "error",
          });
        }
        EventBus.$emit("displaySnackbar", {
          display: true,
          text: this.$t("location.locationUpdated"),
          color: "success",
        });
      }
      if(type === 2) {
        try {
          await this.$Amplify.API.post(
            "appointments",
            "/appointments/services",
            myInit
          );
        } catch (err) {
          EventBus.$emit("displaySnackbar", {
            display: true,
            text: err.message,
            color: "error",
          });
        }
        EventBus.$emit("displaySnackbar", {
          display: true,
          text: this.$t("location.locationCreated"),
          color: "success",
        });
      }
      this.goToServicesList();
    },
    goToServicesList() {
        this.$router.push("/appointment-services");
    },
    setUpdate() {
      this.duration = this.duration_props;
      this.enabled = this.enabled_props;

      if (typeof this.service_name_props === 'object') {
        this.serviceName = this.service_name_props;
        if (Object.keys(this.serviceName).length > 0 && Object.keys(this.serviceName).includes(this.$root.$i18n.locale)) {
          this.serviceNameLang = this.$root.$i18n.locale
        } else if (Object.keys(this.serviceName).length > 0) {
          this.serviceNameLang = Object.keys(this.serviceName)[0]
        }
      } else {
        this.serviceName = {
          [this.$root.$i18n.locale]: this.service_name_props
        }
        this.serviceNameLang = this.$root.$i18n.locale
      }
      this.videoConference = this.videoconference_props;
      this.sellerService = this.seller_service_props;
    },
    async deleteService() {
      let myInit = {
        headers: {
          Authorization: "Bearer " + this.$auth.accessToken,
        },
      };
      try {
        await this.$Amplify.API.del(
          "appointments",
          `/appointments/services/${this.id}`,
          myInit
        );
      } catch (err) {
        EventBus.$emit("displaySnackbar", {
          display: true,
          text: err.message,
          color: "error",
        });
      }
      EventBus.$emit("displaySnackbar", {
        display: true,
        text: this.$t("location.locationDeleted"),
        color: "success",
      });
      this.goToServicesList();
    },
    deleteServiceLang(values) {
      this.$delete(this.serviceName, values)
      this.serviceNameLang = this.getFirstObjectKey(this.serviceName)
      this.key = Date.now()
    },
    getFirstObjectKey (data) {
      let value = ''
      if (Object.keys(data).length) {
        value = Object.keys(data)[0]
      }
      return value
    }
  },
};
</script>

<style scoped>
.card-title {
  word-break: normal !important;
}
.row-appointment-default {
  display: flex;
  align-items: baseline;
  margin: 15px 0;
}

#cancel-service {
    cursor: pointer;
}
</style>
